import { Tooltip } from "@mui/material";

import Icon from "@musicfy/components/Icon";
import Slider from "@musicfy/components/Slider";

interface IPitchSliderProps {
  value: number;
  handleChange: (value: number) => void;
}

const FormantSlider = ({ value, handleChange }: IPitchSliderProps) => {
  return (
    <div className="p-5 flex lg:flex-row flex-col lg:items-center rounded-12 bg-white/2 border border-solid border-white/25">
      <Tooltip
        arrow
        title="Preserves the original pitch and notes of the audio while changing the sound/timbre."
      >
        <div className="flex items-center gap-2 cursor-pointer">
          <Icon name="help" className="pb-[2px]" />
          <div className="whitespace-nowrap">Formant Shift:</div>
        </div>
      </Tooltip>
      <div className="w-full lg:ml-[40px] gap-6 flex items-center justify-center">
        <Slider
          value={value}
          step={0.05}
          min={0.1}
          max={2}
          size="small"
          onChange={(e, val) => {
            handleChange(val as number);
          }}
        />
        <div>{value}</div>
      </div>
    </div>
  );
};

export default FormantSlider;
